import React from "react";
import { View, StyleSheet } from "react-native";
import CustomText from "../../components/common/general/CustomText/CustomText";

const ChatHeader = () => {
  return (
    <View style={styles.header}>
      <CustomText text="General Chat" useTranslationText={false} weight="ultraBold" style={styles.title} />
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    height: 48,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 20,
    borderBottomColor: "#EAECF0",
    borderBottomWidth: 1,
    backgroundColor: "#FFFFFF",
  },
  title: {
    color: "#101828",
    fontSize: 16,
  },
});

export default ChatHeader;
